module.exports = __webpack_public_path__ + "img/piece-of-cake.13d2da1c.svg";